<template>
  <div>
    <!-- Filter -->
    <FilterJobLibraries
      :filters="categoryJobLibrary.params"
      :show-modal-filter="modalFilter"
      @close="modalFilter = false"
      @apply-filter="fetchData()"
      tab="category"
    />

    <template v-if="modalFleet">
      <SelectFleetJobLibrary
        :isOpen="modalFleet"
        @close="modalFleet = false"
        @next="onSelectedFleets"
        :jobLibraryIds="selectedJobIds"
      ></SelectFleetJobLibrary>
    </template>

    <CustomSidebar v-model="showSidebar" size="100%" title="New Job Library">
      <template v-if="showSidebar">
        <FormAssignFleets
          :selectedFleets="selectedFleets"
          @close="showSidebar = false"
          @refetch="fetchData"
        />
      </template>
    </CustomSidebar>

    <template>
      <!-- Table -->
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <div class="d-flex mb-3">
            <b-form-input
              id="fleet_name"
              style="width: 200px"
              type="text"
              placeholder="Search..."
              v-model="categoryJobLibrary.params.search"
            ></b-form-input>
          </div>
          <b-button
            variant="outline-primary"
            class="d-flex align-items-center ml-2"
            style="height: max-content"
            @click="modalFilter = true"
          >
            <i class="fas fa-sliders"></i>
            <p class="text-truncate m-0">Filter Data</p>
          </b-button>
        </div>
        <div class="d-flex">
          <ImportAssignJobToFleetModal :refetch="fetchData" />
          <b-button
            class="ml-2 d-flex align-items-center"
            style="height: max-content"
            :disabled="!checkedJobs.length"
            variant="primary"
            @click="handleOpenModalAssign"
          >
            <i class="fa fa-plus mr-1"></i>
            Assign Library To Fleet
          </b-button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="thead-light">
            <tr>
              <th>
                <b-form-checkbox
                  class="d-flex justify-content-center"
                  :checked="isCheckedAll"
                  @change="toggleSelectAll"
                />
              </th>
              <th>Category Equipment</th>
              <th>Used For</th>
              <th>Total Equipment</th>
              <th>Calendar Trigger</th>
              <th>Counter Trigger</th>
              <th align="center" class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(job, index) in categoryJobLibrary.data" :key="index">
              <td>
                <b-form-checkbox
                  type="checkbox"
                  :value="job.id"
                  v-model="checkedJobs"
                  class="d-flex justify-content-center"
                />
              </td>
              <td>{{ job.component_name }}</td>
              <td>
                <span
                  v-for="(type, i) in job.used_for"
                  :key="i"
                  class="badge badge-light border mr-1 mb-1"
                >
                  {{ type?.name }}
                </span>
              </td>
              <td>{{ job.total_equipment ?? '-' }} Equipment</td>
              <td>{{ job.calendar_trigger?.count ?? '0' }} Equipment</td>
              <td>{{ job.counter_trigger?.count ?? '0' }} Equipment</td>
              <td align="center">
                <b-dropdown
                  size="sm"
                  variant="outline-primary"
                  text="Action"
                  right
                >
                  <b-dropdown-item @click.prevent="addInterval(job)">
                    Detail Library Interval
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click.prevent="deleteJob(job)"
                    class="text-danger"
                  >
                    Delete
                  </b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="mt-4 d-flex align-items-center w-100 justify-content-end">
          <b-pagination
            class="mb-0 mr-3"
            @input="() => fetchData(categoryJobLibrary.params.page)"
            v-model="categoryJobLibrary.params.page"
            :total-rows="categoryJobLibrary.params.total"
            :per-page="categoryJobLibrary.params.limit"
            first-number
            align="center"
          ></b-pagination>
          <b-form-select
            plain
            v-model="categoryJobLibrary.params.limit"
            :options="limitOptions"
            style="width: 140px"
            @input="() => fetchData()"
          ></b-form-select>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import { fleetsActions, pmsActions } from '@/src/Utils/helper'
import FormAssignFleets from './FormAssignFleets.vue'
import SelectFleetJobLibrary from './Components/SelectFleetJobLibrary.vue'
import FilterJobLibraries from './Components/FilterJobLibraries.vue'
import { debounce } from 'lodash'
import ImportAssignJobToFleetModal from './Components/ImportAssignJobToFleetModal.vue'

export default {
  components: {
    CustomSidebar,
    SelectFleetJobLibrary,
    FormAssignFleets,
    FilterJobLibraries,
    ImportAssignJobToFleetModal,
  },
  data() {
    return {
      showSidebar: false,
      limitOptions,
      categoryJobLibrary: {
        params: {
          search: '',
          vehicleTypeIds: [],
          maintenance_component_id: [],
          jobClassIds: [],
          jobTypeIds: [],
          active: true,
          page: 1,
          limit: 10,
          total: 10,
          totalPages: 1,
        },
        data: [],
      },
      checkedJobs: [],
      selectedJobIds: [],
      selectedFleets: [],
      modalFilter: false,
      modalFleet: false,
    }
  },
  computed: {
    filteredData() {
      return this.categoryJobLibrary.data.filter((job) =>
        job.name.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    isCheckedAll() {
      return this.categoryJobLibrary.data.every((el) =>
        this.checkedJobs.some((job) => job == el.id)
      )
    },
    totalPages() {
      return 5
    },
  },
  methods: {
    ...fleetsActions,
    ...pmsActions,

    // Debounced search method
    debouncedSearch: debounce(function () {
      this.categoryJobLibrary.params.page = 1 // Reset ke halaman pertama
      this.fetchData()
    }, 500), // 500ms delay

    onSelectedFleets(fleets) {
      console.log(fleets)
      this.selectedFleets = fleets
      this.showSidebar = true
    },
    async fetchData() {
      const params = this.categoryJobLibrary.params
      const payload = {
        page: params.page,
        limit: params.limit,
        search: params.search,
        maintenance_component_id: params.maintenance_component_id?.toString(),
        // job_class_id: params.jobClassIds.toString(),
        // job_type_id: params.jobTypeIds?.toString(),
        vehicleTypeId: params.vehicleTypeIds?.toString(),
      }
      const res = await this.getJobLibrayrCategory(payload)

      if (res?.status === 'success') {
        const { data } = res.data
        this.categoryJobLibrary.data = data
        this.categoryJobLibrary.params = {
          ...this.categoryJobLibrary.params,
          total: res.data?.totalRows,
          totalPages: res.data.totalPages,
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
    async handleOpenModalAssign() {
      if (this.checkedJobs.length === 0) {
        this.$swal('Gagal!', 'Pilih Job Library Terlebih Dahulu!', 'error')
      } else {
        const selectedData = this.categoryJobLibrary.data.filter((el) =>
          this.checkedJobs?.includes(el.id)
        )
        this.selectedJobIds = selectedData
          .map((item) => item.job_libraries.map((el) => el.id))
          .flat()
        this.modalFleet = true
      }
    },
    toggleSelectAll(checked) {
      const currentPageIds = this.categoryJobLibrary.data.map((job) => job.id)
      if (checked) {
        const unique = new Set([...this.checkedJobs, ...currentPageIds])
        this.checkedJobs = Array.from(unique)
      } else {
        this.checkedJobs = this.checkedJobs.filter(
          (id) => !currentPageIds.includes(id)
        )
      }
    },
    addInterval(item) {
      this.$router.push({
        path: '/maintenance/job-library-per-category',
        query: {
          maintenance_component_id: item.id,
          component_name: item.component_name,
        },
      })
    },
    deleteJob(job) {
      alert('Delete: ' + job.name)
    },
  },

  watch: {
    // Watcher untuk search dengan debounce
    'categoryJobLibrary.params.search'() {
      this.debouncedSearch()
    },

    checkedJobs(newVal) {
      // const filteredData = this.categoryJobLibrary.filter((el)=> newVal?.includes(el.id))
      // this.selectedJobIds = filteredData.map((el)=> el.id)
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
.table td,
.table th {
  vertical-align: middle;
}
.badge {
  font-size: 0.8rem;
  padding: 0.4em 0.6em;
}
</style>
